import { Children } from "react";

import {
  TableRow,
  TableCell,
  Typography,
  TableBody,
  styled,
  Box,
} from "@mui/material";
import { format } from "date-fns";
import { memo } from "utils/memo";
import T from "utils/constants/T";
import { get } from "lodash";
import "./walletTable.css";
import { formatAmount } from "utils/CommonMethods";
import { useSelector } from "react-redux";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderTop: "inherit",
  overflow: "hidden",
  padding: "8px 0px 8px 10px",
}));
interface WalletBodyProps {
  allTableRows: any[];
  page: number;
  rowsPerPage: number;
  totalTableRowsCount: number;
  totalPageCount: number;
  opan: boolean;
  anchorEl: any;
  handleClick: any;
  handleClose: any;
  isLoading?: boolean;
}

const WalletBody = ({
  allTableRows = [],
  page,
  rowsPerPage,
  totalTableRowsCount,
  totalPageCount,
  opan,
  anchorEl,
  handleClick,
  handleClose,
  isLoading,
}: WalletBodyProps) => {
  const { currencySymbol } = useSelector((state: any) => state.companyTabData);
  const cs = currencySymbol ? currencySymbol : T.DOLLAR;
  return (
    <TableBody>
      {isLoading ? (
        <TableRow>
          <StyledTableCell colSpan={10} sx={{ border: "none" }}>
            <Typography variant="body1" textAlign="center">
              {T.LOADING}
            </Typography>
          </StyledTableCell>
        </TableRow>
      ) : (
        <>
          {allTableRows && allTableRows.length === 0 ? (
            <TableRow>
              <StyledTableCell colSpan={10} sx={{ border: "none" }}>
                <Typography variant="body1" textAlign="center">
                  {T.NO_RECORDS}
                </Typography>
              </StyledTableCell>
            </TableRow>
          ) : (
            Children.toArray(
        allTableRows.filter(Boolean).map((record) => {
          const startDate = get(record, "start_date", "");
          const endDate = get(record, "end_date", "");
          const startDateFormatted = new Date(startDate);
          const endDateFormatted = new Date(endDate);
          const startDateText = format(startDateFormatted, "dd MMM yyyy");
          const endDateText = format(endDateFormatted, "dd MMM yyyy");
          const accured_amount_total = get(
            record,
            "pay_calculates.accured_amount_total",
            ""
          );
          const withdrawalsTotal = get(
            record,
            "pay_calculates.withdrawals_total",
            ""
          );
          const salaryBalance =
            accured_amount_total - withdrawalsTotal < 0
              ? 0
              : accured_amount_total - withdrawalsTotal;

          return (
            <TableRow
              sx={{ background: "white" }}
              key={`${startDate}-${endDate}-${withdrawalsTotal}-${salaryBalance}`}
            >
              <StyledTableCell>
                {get(record, "staff_infor.fullname", "")}
              </StyledTableCell>
              <StyledTableCell>
                {get(record, "staff_infor.email", "")}
              </StyledTableCell>
              <StyledTableCell>
                {get(record, "staff_infor.system_employee_id", "")}
              </StyledTableCell>
              {/* <StyledTableCell>{createdDateText}</StyledTableCell> */}
              <StyledTableCell>
                <Box className="table-column">
                  {startDateText} To {endDateText}
                </Box>
              </StyledTableCell>
              <StyledTableCell>
                {`${cs}` +
                  formatAmount(
                    get(record, "pay_calculates.amount_available", "") < 0
                      ? 0
                      : get(record, "pay_calculates.amount_available", "")
                  )}
              </StyledTableCell>
              <StyledTableCell>
                {`${cs}` +
                  formatAmount(
                    get(record, "pay_calculates.accured_amount_total", "")
                  )}
              </StyledTableCell>
              <StyledTableCell>
                {`${cs}` +
                  formatAmount(get(record, "pay_calculates.limit_amount", ""))}
              </StyledTableCell>
              <StyledTableCell>
                {`${cs}` +
                  formatAmount(get(record, "pay_calculates.current_fee", ""))}
              </StyledTableCell>
              <StyledTableCell>
                {`${cs}` +
                  formatAmount(
                    get(record, "pay_calculates.withdrawals_total", "")
                  )}
              </StyledTableCell>
              <StyledTableCell>
                {`${cs}` + formatAmount(salaryBalance)}
              </StyledTableCell>
            </TableRow>
          );
        })
            )
          )}
        </>
      )}
    </TableBody>
  );
};

export default memo(WalletBody);
